export default "__VITE_ASSET__BxxeyezJ__"